import { getFullName } from "shared/utils/get-full-name";
import {
  CombinedIncomeRerunCanceledActivity,
  CombinedIncomeRerunCompletedActivity,
  CombinedIncomeRerunRequestedActivity,
  NewIncomeRequestCanceledActivity,
  NewIncomeRequestCompletedActivity,
  NewIncomeRequestCreatedActivity
} from "../types";
import { getApplicantRole } from "utils/getApplicantRole";

type IncomeRerunActivity =
  | CombinedIncomeRerunRequestedActivity
  | CombinedIncomeRerunCanceledActivity
  | CombinedIncomeRerunCompletedActivity
  | NewIncomeRequestCreatedActivity
  | NewIncomeRequestCanceledActivity
  | NewIncomeRequestCompletedActivity;

const getApplicantLabel = (
  contact: CombinedIncomeRerunRequestedActivity["details"]["contact"]
) => {
  const name = getFullName({
    firstName: contact.first_name,
    lastName: contact.last_name,
    middleName: contact.middle_name,
    short: true
  });
  const role = contact.role
    ? getApplicantRole(contact.role, contact.is_primary)
    : null;
  return role ? `${name} (${role})` : name;
};

export const CombinedIncomeReportRerun = ({
  activity
}: {
  activity: IncomeRerunActivity;
}) => {
  const applicantLabel = getApplicantLabel(activity.details.contact);
  const authorLabel = activity.author?.name ?? activity.author?.email ?? "";

  if (activity.activity_type === "combined_income_rerun_requested")
    return (
      <div>
        <p>
          <span className="font-bold">Income re-verification request</span>
          {authorLabel && ` was sent by ${authorLabel}`}
        </p>
        <p className="text-sm text-content-400 mt-2">to {applicantLabel}</p>
      </div>
    );

  if (activity.activity_type === "combined_income_rerun_canceled")
    return (
      <div>
        <p>
          <span className="font-bold">
            Income re-verification request was canceled
          </span>
          {authorLabel && ` by ${authorLabel}`}
        </p>
        <p className="text-sm text-content-400 mt-2">for {applicantLabel}</p>
      </div>
    );

  if (activity.activity_type === "new_income_request_created")
    return (
      <div>
        <p>
          <span className="font-bold">Income verification request</span>
          {authorLabel && ` was sent by ${authorLabel}`}
        </p>
        <p className="text-sm text-content-400 mt-2">to {applicantLabel}</p>
      </div>
    );

  if (activity.activity_type === "new_income_request_canceled")
    return (
      <div>
        <p>
          <span className="font-bold">
            Income verification request was canceled
          </span>
          {authorLabel && ` by ${authorLabel}`}
        </p>
        <p className="text-sm text-content-400 mt-2">for {applicantLabel}</p>
      </div>
    );

  if (activity.activity_type === "new_income_request_completed")
    return (
      <div>
        <p>
          <span className="font-bold">Income verification was completed</span>
        </p>
        <p className="text-sm text-content-400 mt-2">by {applicantLabel}</p>
      </div>
    );

  return (
    <div>
      <p>
        <span className="font-bold">Income re-verification was completed</span>
      </p>
      <p className="text-sm text-content-400 mt-2">by {applicantLabel}</p>
    </div>
  );
};
